document.addEventListener("DOMContentLoaded", function() {
    const reviewWrappers = document.querySelectorAll('.mf_review-video-wrap');

    reviewWrappers.forEach(function(wrapper) {
      const thumbnail = wrapper.querySelector('.mf_review-thumbnail');
      const video = wrapper.querySelector('video');
      const iframe = wrapper.querySelector('iframe');

        if (video) {
          const videoImage = video.querySelector("img");
          if (videoImage) {
            videoImage.alt = "video poster image";
            videoImage.loading = "lazy";
          }
        }
  
        if (thumbnail) {
            thumbnail.addEventListener('click', function() {
                thumbnail.style.display = 'none';
                wrapper.classList.add('active');

                if (video) {
                    video.style.display = 'inline-block';
                    video.play().catch(() => {});
                }
                if (iframe) {
                    iframe.style.display = 'inline-block';
                    if (!iframe.src.includes('autoplay=1')) {
                        let joinChar = iframe.src.includes('?') ? '&' : '?';
                        iframe.src = iframe.src + joinChar + 'autoplay=1';
                    }
                }
            });
        }
    });
  });

  document.addEventListener("DOMContentLoaded", function () {
    const section = document.querySelector(".mf_review-sec");
    const leftCol = document.querySelector(".mf_review-left-column");
    const rightCol = document.querySelector(".mf_review-right-column");
  
    if (!section || !leftCol || !rightCol) return;
  
    window.addEventListener("scroll", function () {
      const rect = section.getBoundingClientRect();
      const sectionTop = rect.top + window.scrollY;
      const sectionHeight = rect.height;
      const scrollY = window.scrollY;
      const windowHeight = window.innerHeight;
  
      const offset = 200; // start animation 200px before section enters
  
      if (window.innerWidth > 767) {
        // Desktop → vertical parallax
        if (scrollY + windowHeight >= sectionTop - offset && scrollY <= sectionTop + sectionHeight) {
          const progress = (scrollY + offset - sectionTop) / sectionHeight;
          const speed = 80;
  
          leftCol.style.transform = `translateY(${progress * speed}px)`;
          rightCol.style.transform = `translateY(${-progress * speed}px)`;
        }
      } else {
        // Mobile → horizontal parallax
        if (scrollY + windowHeight >= sectionTop - offset && scrollY <= sectionTop + sectionHeight) {
          const progress = (scrollY + offset - sectionTop) / sectionHeight;
          const speed = 30;
  
          leftCol.style.transform = `translateX(${-progress * speed}px)`;
          rightCol.style.transform = `translateX(${progress * speed}px)`;
        }
      }
    });
  });
  